import Image from "next/image";
import { Button } from "@/components/ui/button";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { memo } from "react";
import Icon from "@/components/ui/Icon";
import ArrowLink from "@/components/ui/arrow-link";

export type ServiceCardSmallProps = {
  title: string;
  description?: string;
  link?: string;
  linkLabel?: string;
  isStatic?: boolean;
} & React.ComponentProps<"div">;

const ServiceCardSmall = ({
  title,
  description,
  link = "#",
  linkLabel,
  isStatic = false,
  className,
}: ServiceCardSmallProps) => {
  const cardContent = (
    <div
      className={cn(
        "flex rounded-2xl p-5 bg-white h-full",
        {
          "bg-blue": isStatic,
          "cursor-pointer hover:shadow-lg transition-shadow": isStatic && link,
        },
        className
      )}
    >
      <div
        className={cn("flex flex-col flex-auto min-w-0", {
          "justify-end": isStatic,
        })}
      >
        {isStatic && (
          <Icon
            id="icon-file-text_59"
            width={58}
            height={58}
            className="shrink-0 w-[58] h-[58] text-white"
          />
        )}
        <div
          className={cn("grid grid-cols-1 gap-3", { "gap-4 mt-4": isStatic })}
        >
          <div
            className={cn("text-xl leading-[150%] font-semibold", {
              "text-white": isStatic,
              "text-semantic-text-primary lg:text-gray-800": !isStatic,
            })}
          >
            <h4>{title}</h4>
          </div>
          {!isStatic && (
            <div className="text-sm leading-[150%] text-semantic-text-primary lg:text-gray-600">
              <p>{description}</p>
            </div>
          )}
          {isStatic && (
            <div className="flex">
              <Icon
                id="icon-arrow-right_34"
                width={33}
                height={24.12}
                className="shrink-0 w-[33] h-[24.12] text-white"
              />
            </div>
          )}
        </div>
        {!isStatic && linkLabel && (
          <div className="mt-auto pt-3 lg:pt-7 flex">
            <ArrowLink href={link}>{linkLabel}</ArrowLink>
          </div>
        )}
      </div>
    </div>
  );

  if (isStatic && link) {
    return (
      <Link href={link} className="block h-full">
        {cardContent}
      </Link>
    );
  }

  return cardContent;
};
export default memo(ServiceCardSmall);
